/**
 * "This Day in Tech History" — one fact per day of year (1-366).
 * Keyed by day-of-year so there's no API call needed.
 */

const facts: Record<number, string> = {
  // January
  1: 'In 1983, ARPANET officially switched to TCP/IP, marking the birth of the modern Internet.',
  2: 'In 2004, NASA\'s Stardust spacecraft successfully collected samples from Comet Wild 2.',
  3: 'In 1977, Apple Computer was incorporated by Steve Jobs, Steve Wozniak, and Ronald Wayne.',
  4: 'In 2010, the Burj Khalifa in Dubai was officially opened as the tallest building in the world at 828 meters.',
  5: 'In 2007, Apple CEO Steve Jobs unveiled the first iPhone at Macworld in San Francisco.',
  6: 'In 1838, Samuel Morse first publicly demonstrated his telegraph in Morristown, New Jersey.',
  7: 'In 1927, the first transatlantic telephone call was made from New York to London.',
  8: 'In 1889, Herman Hollerith received a patent for his electric tabulating machine, forerunner to IBM.',
  9: 'In 2007, Steve Jobs announced the iPhone at Macworld, calling it "a revolutionary product."',
  10: 'In 1946, the first radar signal was bounced off the Moon by the U.S. Army Signal Corps.',
  11: 'In 1964, U.S. Surgeon General Luther Terry published the first report linking smoking to cancer.',
  12: 'In 2010, a magnitude 7.0 earthquake struck Haiti; tech volunteers built crisis-mapping platforms in hours.',
  13: 'In 1990, a software bug crashed AT&T\'s long-distance network, dropping 75 million calls.',
  14: 'In 2005, the Huygens probe landed on Saturn\'s moon Titan, the farthest landing from Earth.',
  15: 'In 2001, Wikipedia went live, eventually becoming the largest encyclopedia in history.',
  16: 'In 2003, Space Shuttle Columbia launched on its final mission, STS-107.',
  17: 'In 2007, the Doomsday Clock was moved to 5 minutes to midnight due to nuclear and climate threats.',
  18: 'In 1911, Eugene Ely performed the first aircraft landing on a ship, USS Pennsylvania.',
  19: 'In 1983, Apple introduced the Lisa, the first personal computer with a graphical user interface.',
  20: 'In 1996, Yasser Arafat was elected as the first President of the Palestinian National Authority.',
  21: 'In 1976, the Concorde made its first commercial supersonic flight.',
  22: 'In 1984, Apple aired the famous "1984" Macintosh commercial during Super Bowl XVIII.',
  23: 'In 1997, Madeleine Albright became the first female U.S. Secretary of State.',
  24: 'In 1984, Apple launched the Macintosh, the first mass-market PC with a graphical user interface.',
  25: 'In 2004, the Mars rover Opportunity landed on Mars and operated for over 14 years.',
  26: 'In 1926, John Logie Baird gave the first public demonstration of television.',
  27: 'In 1967, three NASA astronauts died in the Apollo 1 fire, leading to major safety reforms.',
  28: 'In 1986, the Space Shuttle Challenger broke apart 73 seconds after launch.',
  29: 'In 2010, Apple\'s Steve Jobs unveiled the first iPad tablet computer.',
  30: 'In 1969, the Beatles performed their last public concert on the rooftop of Apple Corps.',
  31: 'In 1958, Explorer 1 became the first U.S. satellite to reach orbit, discovering the Van Allen belts.',

  // February
  32: 'In 2003, the Space Shuttle Columbia disintegrated during re-entry, killing all seven crew members.',
  33: 'In 1977, the first test flight of the Space Shuttle Enterprise took place atop a Boeing 747.',
  34: 'In 2004, Mark Zuckerberg launched "TheFacebook" from his Harvard dorm room.',
  35: 'In 1997, a clone named Dolly the Sheep was first announced to the public.',
  36: 'In 1971, Apollo 14 astronaut Alan Shepard hit two golf balls on the Moon.',
  37: 'In 1959, Barbie made her debut at the American International Toy Fair in New York City.',
  38: 'In 2016, LIGO announced the first direct detection of gravitational waves.',
  39: 'In 1893, Thomas Edison completed construction of the first motion picture studio.',
  40: 'In 1996, Deep Blue became the first computer to win a chess game against a reigning world champion.',
  41: 'In 1990, the Hubble Space Telescope was launched into orbit aboard Space Shuttle Discovery.',
  42: 'In 2005, YouTube.com was activated as a domain name by Chad Hurley, Steve Chen, and Jawed Karim.',
  43: 'In 1955, ENIAC, the first general-purpose electronic computer, was retired after 10 years of service.',
  44: 'In 2008, Toshiba announced it would discontinue HD DVD, ending the format war with Blu-ray.',
  45: 'In 1946, ENIAC was formally dedicated at the University of Pennsylvania as the first general-purpose computer.',
  46: 'In 1978, the first computer bulletin board system (BBS) was created in Chicago.',
  47: 'In 1995, Kevin Mitnick, the most-wanted computer hacker in the U.S., was arrested by the FBI.',
  48: 'In 2009, the first Bitcoin transaction took place between Satoshi Nakamoto and Hal Finney.',
  49: 'In 1954, the first mass vaccination of children against polio began in Pittsburgh.',
  50: 'In 2004, NASA\'s Opportunity rover confirmed that Mars once had liquid water.',
  51: 'In 2017, SpaceX announced it would fly two private citizens around the Moon in 2018.',
  52: 'In 1991, Tim Berners-Lee published the first web page, describing the World Wide Web project.',
  53: 'In 1998, the Netscape browser source code was released, launching the open-source Mozilla project.',
  54: 'In 2012, the Raspberry Pi single-board computer was released for $35.',
  55: 'In 1991, the World Wide Web was made available to the public outside of CERN.',
  56: 'In 2010, Chile experienced an 8.8 magnitude earthquake; Twitter became a key communication tool.',
  57: 'In 1940, Martin Kamen and Sam Ruben discovered carbon-14, enabling radiocarbon dating.',
  58: 'In 1953, James Watson and Francis Crick discovered the double-helix structure of DNA.',
  59: 'In 2000, the Millennium Bug (Y2K) cleanup was declared officially complete with minimal impact.',

  // March
  60: 'In 1998, the Palm III PDA was introduced, popularizing handheld computing.',
  61: 'In 1949, the first non-stop flight around the world was completed by a USAF B-50 Superfortress.',
  62: 'In 1876, Alexander Graham Bell made the first successful telephone call to his assistant.',
  63: 'In 2012, the Encyclopedia Britannica announced it would stop printing after 244 years.',
  64: 'In 1993, Intel shipped the first Pentium processor chips.',
  65: 'In 2009, the Kepler space telescope launched to search for Earth-like planets.',
  66: 'In 1989, Tim Berners-Lee submitted a proposal for the World Wide Web at CERN.',
  67: 'In 2006, Twitter co-founder Jack Dorsey sent the first-ever tweet: "just setting up my twttr."',
  68: 'In 2014, Facebook acquired Oculus VR for $2 billion, betting big on virtual reality.',
  69: 'In 1953, Jonas Salk announced his polio vaccine was ready for testing.',
  70: 'In 1876, Alexander Graham Bell was granted a patent for the telephone.',
  71: 'In 1999, the first version of Napster was released, revolutionizing music distribution.',
  72: 'In 2006, Amazon Web Services (S3) launched, kickstarting the cloud computing revolution.',
  73: 'In 2016, AlphaGo defeated world Go champion Lee Sedol in a historic AI milestone.',
  74: 'In 1983, Motorola received FCC approval for the DynaTAC, the first commercial cell phone.',
  75: 'In 2018, Cambridge Analytica\'s misuse of Facebook data was revealed, sparking privacy debates.',
  76: 'In 1979, the first spreadsheet program, VisiCalc, was demonstrated, revolutionizing business computing.',
  77: 'In 2010, Instagram co-founder Kevin Systrom started building the photo-sharing app prototype.',
  78: 'In 2000, the NASDAQ Composite peaked at 5,048 before the dot-com bubble burst.',
  79: 'In 2004, Google filed its IPO paperwork with the SEC.',
  80: 'In 1999, "The Matrix" was released, popularizing cyberpunk aesthetics and AI philosophy.',
  81: 'In 2016, Microsoft released the .NET Framework as open source.',
  82: 'In 2015, Apple Watch was announced at the Spring Forward event.',
  83: 'In 2004, Gmail was announced by Google on April Fools\' Day — many thought it was a joke.',
  84: 'In 1968, Stanley Kubrick\'s "2001: A Space Odyssey" premiered, featuring the AI character HAL 9000.',
  85: 'In 1969, the first ARPANET node was installed at UCLA.',
  86: 'In 2010, Apple released the first iPad, creating the modern tablet market.',
  87: 'In 2003, the Human Genome Project was completed, mapping all human genes.',
  88: 'In 2017, SpaceX successfully re-launched and landed a used Falcon 9 rocket for the first time.',
  89: 'In 2016, Elon Musk unveiled the Tesla Model 3, receiving 325,000 pre-orders in the first week.',
  90: 'In 1973, Motorola engineer Martin Cooper made the first handheld cellular phone call.',
  91: 'In 1975, Bill Gates and Paul Allen founded Microsoft in Albuquerque, New Mexico.',

  // April
  92: 'In 2005, Time magazine named Bono and Bill & Melinda Gates as Persons of the Year for philanthropy.',
  93: 'In 1973, the first portable cell phone call was made by Motorola\'s Martin Cooper in New York City.',
  94: 'In 2010, Apple sold over 300,000 iPads on its first day of availability.',
  95: 'In 1998, the Titanic became the first movie to gross over $1 billion worldwide.',
  96: 'In 2016, SpaceX successfully landed a Falcon 9 rocket on a drone ship for the first time.',
  97: 'In 1969, the first artificial heart was implanted by Dr. Denton Cooley.',
  98: 'In 2001, Dennis Tito became the first space tourist, flying to the ISS aboard a Russian Soyuz.',
  99: 'In 2003, the Concorde made its final commercial flight, ending the supersonic travel era.',
  100: 'In 1970, Apollo 13 suffered an oxygen tank explosion; NASA famously improvised to bring the crew home.',
  101: 'In 1981, the first Space Shuttle, Columbia, launched from Kennedy Space Center.',
  102: 'In 2018, Mark Zuckerberg testified before Congress about Facebook\'s data privacy practices.',
  103: 'In 1997, Deep Blue defeated world chess champion Garry Kasparov in a rematch.',
  104: 'In 2003, the Human Genome Project was declared complete ahead of schedule.',
  105: 'In 1955, Ray Kroc opened the first franchised McDonald\'s restaurant in Des Plaines, Illinois.',
  106: 'In 2015, Apple Watch went on sale, with Tim Cook calling it "the most personal device ever."',
  107: 'In 2019, the first image of a black hole was revealed by the Event Horizon Telescope team.',
  108: 'In 2012, Instagram was acquired by Facebook for approximately $1 billion.',
  109: 'In 1970, Apollo 13 launched on what would become NASA\'s most famous "successful failure."',
  110: 'In 2023, SpaceX\'s Starship completed its first integrated test flight from Boca Chica, Texas.',
  111: 'In 1990, the Hubble Space Telescope was deployed from Space Shuttle Discovery.',
  112: 'In 2004, Google announced Gmail with 1 GB of free storage — 500x what rivals offered.',
  113: 'In 1953, Watson and Crick published their DNA double helix paper in Nature.',
  114: 'In 2019, Zoom Video went public, later becoming essential for remote work during the pandemic.',
  115: 'In 2007, the first Kindle was revealed by Amazon founder Jeff Bezos.',
  116: 'In 1977, Apple II was introduced at the West Coast Computer Faire.',
  117: 'In 2015, the Apple Watch officially shipped, selling over 1 million units on launch day.',
  118: 'In 1981, Xerox PARC demonstrated the Star workstation, inspiring the Macintosh.',
  119: 'In 2003, Apple launched the iTunes Music Store with 200,000 songs at $0.99 each.',
  120: 'In 1993, CERN announced the World Wide Web would be free for everyone to use.',
  121: 'In 2012, SpaceX\'s Dragon became the first commercial spacecraft to dock with the ISS.',

  // May
  122: 'In 2011, the final Space Shuttle mission was announced by NASA.',
  123: 'In 1997, IBM\'s Deep Blue defeated world chess champion Garry Kasparov.',
  124: 'In 2020, SpaceX launched NASA astronauts from U.S. soil for the first time since 2011.',
  125: 'In 1961, Alan Shepard became the first American in space aboard Freedom 7.',
  126: 'In 2019, Google announced its quantum processor "Sycamore."',
  127: 'In 1952, Grace Hopper wrote the first compiler, paving the way for modern programming.',
  128: 'In 2012, Facebook held its IPO, valued at $104 billion — the largest tech IPO at the time.',
  129: 'In 2020, SpaceX Crew Dragon successfully launched astronauts to the ISS.',
  130: 'In 2014, Amazon unveiled the Fire Phone with dynamic 3D perspective features.',
  131: 'In 1911, the Indianapolis Motor Speedway held the first Indianapolis 500 race.',
  132: 'In 1990, Windows 3.0 was released by Microsoft, selling 10 million copies in two years.',
  133: 'In 1962, JFK announced the goal of landing a man on the Moon before the decade was out.',
  134: 'In 1997, Garry Kasparov lost the sixth game to Deep Blue, losing the match to a computer.',
  135: 'In 1996, a computer virus called "Melissa" became one of the first to spread via email.',
  136: 'In 2013, Yahoo acquired Tumblr for $1.1 billion.',
  137: 'In 2003, LinkedIn was officially launched, eventually growing to over 900 million members.',
  138: 'In 1954, Texas Instruments produced the first transistor radio.',
  139: 'In 2002, Elon Musk founded SpaceX to reduce space transportation costs.',
  140: 'In 2014, a selfie at the Oscars, tweeted by Ellen DeGeneres, became the most retweeted post ever.',
  141: 'In 1844, Samuel Morse sent the first telegraph message: "What hath God wrought?"',
  142: 'In 2015, Apple Music was announced at WWDC.',
  143: 'In 2008, the Phoenix Mars Lander successfully touched down on Mars.',
  144: 'In 2009, Wolfram Alpha launched, bringing computational knowledge to the web.',
  145: 'In 1977, "Star Wars: A New Hope" was released, revolutionizing movie special effects.',
  146: 'In 2013, the Xbox One was officially unveiled by Microsoft.',
  147: 'In 1995, Java was officially released by Sun Microsystems.',
  148: 'In 2020, SpaceX Crew Dragon Demo-2 launched, restoring U.S. human spaceflight.',
  149: 'In 1953, Edmund Hillary and Tenzing Norgay became the first to summit Mount Everest.',
  150: 'In 1971, the Mariner 9 probe launched toward Mars, becoming the first spacecraft to orbit another planet.',
  151: 'In 2005, Reddit was founded by Steve Huffman and Alexis Ohanian.',
  152: 'In 1975, Steve Wozniak began building the Apple I computer in Steve Jobs\' garage.',

  // June
  153: 'In 2001, Bram Cohen released the first version of BitTorrent.',
  154: 'In 1966, Surveyor 1 landed on the Moon, the first U.S. spacecraft to soft-land on another world.',
  155: 'In 1977, Apple II went on sale — the first mass-produced personal computer.',
  156: 'In 2009, Bing was launched by Microsoft as a replacement for Live Search.',
  157: 'In 2017, Apple unveiled the HomePod smart speaker at WWDC.',
  158: 'In 2014, Apple introduced the Swift programming language at WWDC.',
  159: 'In 1983, the first Sally Ride became the first American woman in space.',
  160: 'In 2010, Apple sold 1.7 million iPhone 4s in the first three days.',
  161: 'In 2015, Apple announced iOS 9 and watchOS 2 at WWDC.',
  162: 'In 1996, Nintendo released the Nintendo 64 in Japan.',
  163: 'In 2012, Microsoft unveiled the Surface tablet, entering the hardware market.',
  164: 'In 2023, Apple unveiled Vision Pro, its first spatial computing headset.',
  165: 'In 2009, Firefox 3.5 was released with support for HTML5 video.',
  166: 'In 2004, Cassini-Huygens entered orbit around Saturn after a 7-year journey.',
  167: 'In 2007, the first iPhone went on sale at Apple Stores across the United States.',
  168: 'In 2001, Wikipedia reached 10,000 articles.',
  169: 'In 1992, the first smartphone, IBM Simon, was demonstrated at COMDEX.',
  170: 'In 2013, Edward Snowden leaked classified NSA documents, sparking global privacy debates.',
  171: 'In 2000, the human genome was declared 90% mapped by President Clinton.',
  172: 'In 1963, Valentina Tereshkova became the first woman in space.',
  173: 'In 2010, Apple sold its 3 millionth iPad, just 80 days after launch.',
  174: 'In 2016, Microsoft acquired LinkedIn for $26.2 billion.',
  175: 'In 1997, Amazon.com held its IPO at $18 per share.',
  176: 'In 1945, Vannevar Bush published "As We May Think," describing a proto-hypertext machine called the Memex.',
  177: 'In 2015, Docker 1.0 was released, revolutionizing software containerization.',
  178: 'In 1969, construction began on ARPANET, the precursor to the Internet.',
  179: 'In 2013, Slack was first released as a team communication tool.',
  180: 'In 2007, the iPhone launched, selling 270,000 units in the first 30 hours.',
  181: 'In 2006, Twitter was publicly launched at the SXSW conference.',
  182: 'In 1908, the Tunguska event flattened 770 sq miles of Siberian forest — still unexplained.',
  183: 'In 2014, Google announced the Cardboard VR viewer at Google I/O.',

  // July
  184: 'In 1979, Sony introduced the Walkman, changing how the world listened to music.',
  185: 'In 1997, Mars Pathfinder landed on Mars, deploying the Sojourner rover.',
  186: 'In 1996, Dolly the Sheep was born, the first mammal cloned from an adult cell.',
  187: 'In 2012, CERN announced the discovery of the Higgs boson particle.',
  188: 'In 1996, Hotmail launched as one of the first web-based email services.',
  189: 'In 2003, Tesla Motors was incorporated, later revolutionizing the electric car industry.',
  190: 'In 2015, New Horizons performed the first flyby of Pluto.',
  191: 'In 1962, Telstar 1 was launched, relaying the first live transatlantic TV signal.',
  192: 'In 1985, Nintendo released the NES in North America, reviving the video game industry.',
  193: 'In 2006, Twitter launched publicly after being an internal Odeo project.',
  194: 'In 2015, Pluto was photographed in detail for the first time by NASA\'s New Horizons.',
  195: 'In 1997, the Mars Pathfinder\'s Sojourner rover sent back its first images.',
  196: 'In 2016, Pokemon Go was released, becoming a global AR gaming phenomenon.',
  197: 'In 1975, the Apollo-Soyuz Test Project docked U.S. and Soviet spacecraft for the first time.',
  198: 'In 1969, Apollo 11 launched from Kennedy Space Center on its mission to the Moon.',
  199: 'In 2010, Uber launched in San Francisco as "UberCab."',
  200: 'In 1969, Neil Armstrong became the first person to walk on the Moon.',
  201: 'In 1969, Buzz Aldrin and Neil Armstrong spent 21 hours on the lunar surface.',
  202: 'In 2013, Royal Baby George was one of the most-tweeted events in history.',
  203: 'In 1962, the first live TV signal was relayed between the U.S. and Europe via Telstar.',
  204: 'In 1998, iMac was introduced by Steve Jobs, saving Apple from near-bankruptcy.',
  205: 'In 2017, Elon Musk received verbal approval to build a Hyperloop between NY and DC.',
  206: 'In 1971, Apollo 15 launched, the first mission to use the Lunar Roving Vehicle.',
  207: 'In 1976, the Viking 1 lander transmitted the first photograph from the surface of Mars.',
  208: 'In 1958, NASA was established by the National Aeronautics and Space Act.',
  209: 'In 2015, Windows 10 was released as a free upgrade for Windows 7 and 8 users.',
  210: 'In 2012, Curiosity rover launched toward Mars, later making groundbreaking discoveries.',
  211: 'In 2004, Amazon acquired the Chinese e-commerce site Joyo.com.',
  212: 'In 1999, Napster launched, disrupting the entire music industry overnight.',
  213: 'In 1981, MTV launched with the words "Ladies and gentlemen, rock and roll."',
  214: 'In 1992, the World Wide Web became publicly available outside CERN.',

  // August
  215: 'In 2018, Apple became the first U.S. public company to be valued at over $1 trillion.',
  216: 'In 1977, the Voyager 2 spacecraft was launched, later visiting four outer planets.',
  217: 'In 2016, Uber launched its first self-driving car pilot in Pittsburgh.',
  218: 'In 1997, Steve Jobs returned to Apple as interim CEO, beginning the company\'s turnaround.',
  219: 'In 1957, the first FORTRAN program was run by IBM, pioneering high-level programming.',
  220: 'In 2012, Curiosity rover successfully landed on Mars using the "sky crane" technique.',
  221: 'In 1991, the World Wide Web was publicly announced by Tim Berners-Lee on the alt.hypertext newsgroup.',
  222: 'In 2015, Google announced its restructuring under a new parent company called Alphabet.',
  223: 'In 1966, Lunar Orbiter 1 took the first photograph of Earth from the Moon\'s orbit.',
  224: 'In 1995, Windows 95 was released, with the Rolling Stones\' "Start Me Up" as its theme song.',
  225: 'In 2011, Steve Jobs resigned as CEO of Apple, with Tim Cook taking over.',
  226: 'In 1920, the 19th Amendment was ratified, granting women the right to vote in the U.S.',
  227: 'In 1859, the first oil well was drilled in Titusville, Pennsylvania.',
  228: 'In 1963, Martin Luther King Jr. delivered his "I Have a Dream" speech.',
  229: 'In 2005, Hurricane Katrina made landfall; tech companies mobilized for disaster response.',
  230: 'In 2017, Hurricane Harvey struck Texas; Zello and social media became emergency tools.',
  231: 'In 1993, the Mosaic web browser was released, popularizing the World Wide Web.',
  232: 'In 2012, South Korean courts found both Apple and Samsung guilty of patent infringement.',
  233: 'In 1977, Voyager 1 launched from Cape Canaveral, now the most distant human-made object.',
  234: 'In 2009, The Walt Disney Company acquired Marvel Entertainment for $4 billion.',
  235: 'In 2001, the first wiki conference was held in Portland, Oregon.',
  236: 'In 1989, Voyager 2 made its closest approach to Neptune.',
  237: 'In 2010, the 33 Chilean miners were found alive after 17 days trapped underground.',
  238: 'In 2013, Elon Musk unveiled the Hyperloop concept in a white paper.',
  239: 'In 2017, the total solar eclipse was the most-watched astronomical event in U.S. history.',
  240: 'In 1998, Google was officially incorporated by Larry Page and Sergey Brin.',
  241: 'In 2011, Siri was introduced as a feature of the iPhone 4S.',
  242: 'In 2003, Mars made its closest approach to Earth in 60,000 years.',
  243: 'In 1999, Bluetooth 1.0 was released, enabling short-range wireless communication.',
  244: 'In 1965, Gemini V launched, proving humans could survive in space for the time needed for a Moon trip.',

  // September
  245: 'In 1998, Google was founded in a garage in Menlo Park, California.',
  246: 'In 2020, TikTok avoided a U.S. ban after Oracle was chosen as its "trusted technology partner."',
  247: 'In 1995, eBay was founded by Pierre Omidyar as AuctionWeb.',
  248: 'In 2013, Grand Theft Auto V earned $1 billion in its first three days — the fastest-selling game ever.',
  249: 'In 2014, Alibaba went public at $25 billion, the largest IPO in history at the time.',
  250: 'In 1956, IBM launched RAMAC, the first commercial computer with a hard disk drive.',
  251: 'In 2014, Apple Pay was announced alongside the iPhone 6.',
  252: 'In 2015, Volkswagen\'s diesel emissions scandal was revealed, affecting 11 million vehicles.',
  253: 'In 2006, Facebook was opened to everyone aged 13 and older, beyond just college students.',
  254: 'In 2014, the iPhone 6 went on sale, with 10 million units sold in the first weekend.',
  255: 'In 1982, the first emoticon :-) was proposed by Scott Fahlman at Carnegie Mellon.',
  256: 'In 2017, Equifax disclosed a data breach affecting 147 million people.',
  257: 'In 1997, Netflix was founded by Reed Hastings and Marc Randolph as a DVD-by-mail service.',
  258: 'In 2011, Spotify launched in the United States after years of success in Europe.',
  259: 'In 1983, Richard Stallman announced the GNU Project to create a free Unix-like OS.',
  260: 'In 2000, the International Space Station received its first permanent crew.',
  261: 'In 2004, SpaceShipOne won the Ansari X Prize for the first private human spaceflight.',
  262: 'In 2008, Google Chrome was released, eventually becoming the world\'s most popular browser.',
  263: 'In 2006, Amazon announced Amazon Elastic Compute Cloud (EC2) in beta.',
  264: 'In 2017, Apple unveiled the iPhone X with Face ID and an edge-to-edge display.',
  265: 'In 2011, CERN scientists measured neutrinos apparently traveling faster than light (later corrected).',
  266: 'In 2013, the iPhone 5S was released with Touch ID, the first mainstream fingerprint sensor on a phone.',
  267: 'In 1998, Google\'s first server was housed in Larry Page\'s dorm room at Stanford.',
  268: 'In 2015, NASA confirmed liquid water flows on present-day Mars.',
  269: 'In 2008, the Large Hadron Collider at CERN was powered up for the first time.',
  270: 'In 1960, the first weather satellite, TIROS-1, was launched by NASA.',
  271: 'In 2001, the iPod was unveiled by Steve Jobs: "1,000 songs in your pocket."',
  272: 'In 2014, Elon Musk unveiled the Tesla D and Autopilot features.',
  273: 'In 1994, Amazon was incorporated by Jeff Bezos in Washington state.',
  274: 'In 2006, Google acquired YouTube for $1.65 billion in stock.',

  // October
  275: 'In 2017, Google rebranded its hardware line under "Made by Google" with the Pixel 2.',
  276: 'In 2018, Microsoft\'s market cap surpassed Apple\'s for the first time since 2010.',
  277: 'In 2008, Elon Musk became CEO of Tesla after the company\'s co-founder was ousted.',
  278: 'In 1957, the Soviet Union launched Sputnik 1, the first artificial satellite.',
  279: 'In 2011, Steve Jobs passed away at age 56, leaving behind a legacy of innovation.',
  280: 'In 2010, Instagram launched on iOS and gained 25,000 users on its first day.',
  281: 'In 2001, Windows XP was released, becoming one of Microsoft\'s most popular operating systems.',
  282: 'In 2016, Samsung permanently discontinued the Galaxy Note 7 after battery fires.',
  283: 'In 1998, the Digital Millennium Copyright Act (DMCA) was signed into U.S. law.',
  284: 'In 2014, the Microsoft Band was released as the company\'s first wearable device.',
  285: 'In 2015, Marty McFly arrived in the future — October 21, 2015 — in "Back to the Future Part II."',
  286: 'In 2001, Apple unveiled the first iPod with a 5GB hard drive and click wheel.',
  287: 'In 2015, the first 3D-printed medication was approved by the FDA.',
  288: 'In 1861, the first transcontinental telegraph message was sent, connecting the U.S. coast to coast.',
  289: 'In 1971, Walt Disney World opened in Orlando, Florida.',
  290: 'In 2014, Tim Cook publicly came out as gay, making him the first openly gay Fortune 500 CEO.',
  291: 'In 1998, the Internet Corporation for Assigned Names and Numbers (ICANN) was created.',
  292: 'In 2001, Apple opened its first retail stores in Virginia and California.',
  293: 'In 1969, ARPANET delivered its first message between UCLA and Stanford.',
  294: 'In 2019, Google announced it achieved "quantum supremacy" with its Sycamore processor.',
  295: 'In 2007, Android was officially announced by Google and the Open Handset Alliance.',
  296: 'In 2001, Apple unveiled the first iPod, holding 1,000 songs in your pocket.',
  297: 'In 2014, Apple launched Apple Pay, bringing contactless payments to the iPhone.',
  298: 'In 2003, Concorde made its final flight, ending the era of commercial supersonic travel.',
  299: 'In 2012, Microsoft released Windows 8 with its controversial tile-based interface.',
  300: 'In 1991, Linus Torvalds released the first version of the Linux kernel.',
  301: 'In 2013, Google announced the Nexus 5, showcasing stock Android.',
  302: 'In 2014, Apple announced the iMac with Retina 5K display.',
  303: 'In 2008, the first Android phone, the T-Mobile G1 (HTC Dream), went on sale.',
  304: 'In 1998, the DMCA was signed, shaping copyright law in the digital age.',
  305: 'In 2016, AT&T announced its acquisition of Time Warner for $85.4 billion.',

  // November
  306: 'In 2016, Adobe announced it would end Flash Player support by the end of 2020.',
  307: 'In 1988, the Morris Worm became one of the first computer worms distributed via the Internet.',
  308: 'In 2007, Amazon launched the Kindle e-reader, which sold out in 5.5 hours.',
  309: 'In 1971, Intel released the 4004, the world\'s first commercial microprocessor.',
  310: 'In 2009, Call of Duty: Modern Warfare 2 earned $550 million in its first five days.',
  311: 'In 2015, Alphabet became the parent company of Google, restructuring the tech giant.',
  312: 'In 2013, Sony released the PlayStation 4, selling 1 million units in 24 hours.',
  313: 'In 1990, Tim Berners-Lee published a formal proposal for the World Wide Web.',
  314: 'In 2004, Firefox 1.0 was released as an open-source alternative to Internet Explorer.',
  315: 'In 2020, PlayStation 5 launched globally to overwhelming demand.',
  316: 'In 1998, AOL announced it would acquire Netscape for $4.2 billion.',
  317: 'In 2020, SpaceX Crew-1 launched, the first operational crewed mission by a private company.',
  318: 'In 2004, Blizzard released World of Warcraft, which eventually reached 12 million subscribers.',
  319: 'In 2006, Nintendo released the Wii, introducing motion-controlled gaming.',
  320: 'In 2022, ChatGPT was released by OpenAI, bringing large language models to the mainstream.',
  321: 'In 1977, Atari released the 2600, popularizing home video game consoles.',
  322: 'In 2000, the Wayback Machine began archiving the web.',
  323: 'In 1859, Charles Darwin published "On the Origin of Species."',
  324: 'In 1963, the first push-button telephone was made available to AT&T customers.',
  325: 'In 2006, the Nintendo Wii launched in North America with Wii Sports.',
  326: 'In 2019, Tesla unveiled the Cybertruck with its unconventional angular design.',
  327: 'In 2001, Microsoft released the first Xbox gaming console.',
  328: 'In 2012, the Raspberry Pi Foundation sold its 1 millionth unit.',
  329: 'In 1929, Commander Richard Byrd completed the first flight over the South Pole.',
  330: 'In 2022, Elon Musk completed the acquisition of Twitter for $44 billion.',
  331: 'In 2016, Amazon Go, a cashierless convenience store, was announced.',
  332: 'In 1954, the first Godzilla film was released in Japan.',
  333: 'In 2013, the Bitcoin price crossed $1,000 for the first time.',
  334: 'In 1998, the International Space Station\'s first module, Zarya, was launched.',
  335: 'In 2015, SpaceX landed a Falcon 9 rocket for the first time at Cape Canaveral.',

  // December
  336: 'In 2020, the UK became the first Western country to approve a COVID-19 vaccine.',
  337: 'In 1980, John Lennon was shot outside his New York City apartment.',
  338: 'In 1968, Douglas Engelbart gave "The Mother of All Demos," showcasing the mouse, hypertext, and video conferencing.',
  339: 'In 2014, NASA\'s Orion spacecraft completed its first test flight.',
  340: 'In 1952, the Great Smog of London began, killing thousands and sparking clean air legislation.',
  341: 'In 1995, Netscape Navigator 2.0 was released with JavaScript support.',
  342: 'In 2001, Wikipedia surpassed 20,000 articles in English.',
  343: 'In 2013, Bitcoin crashed to $522 after China banned financial institutions from using it.',
  344: 'In 1993, astronauts completed the first Hubble Space Telescope servicing mission.',
  345: 'In 1901, Guglielmo Marconi received the first transatlantic radio signal.',
  346: 'In 2005, the first YouTube video to reach 1 million views was a Nike ad featuring Ronaldinho.',
  347: 'In 2003, the CAN-SPAM Act was signed, establishing rules for commercial email.',
  348: 'In 1962, Mariner 2 became the first spacecraft to fly by another planet (Venus).',
  349: 'In 2015, SpaceX successfully landed the first stage of a Falcon 9 orbital rocket.',
  350: 'In 1903, the Wright brothers made the first sustained powered flight at Kitty Hawk.',
  351: 'In 2017, the FCC voted to repeal net neutrality rules.',
  352: 'In 2018, the Parker Solar Probe made its first close approach to the Sun.',
  353: 'In 1972, Apollo 17 launched — the last crewed mission to the Moon.',
  354: 'In 2001, Apple released iTunes, eventually transforming how music was distributed.',
  355: 'In 2015, Elon Musk co-founded OpenAI as a nonprofit AI research lab.',
  356: 'In 1991, the Soviet Union was formally dissolved, ending the Cold War.',
  357: 'In 2004, a massive tsunami struck Southeast Asia; online donations broke records.',
  358: 'In 2013, the world celebrated the 25th anniversary of the World Wide Web.',
  359: 'In 1895, the Lumière brothers held the first public film screening in Paris.',
  360: 'In 2016, Carrie Fisher passed away, prompting an outpouring on social media.',
  361: 'In 1831, Charles Darwin set sail on HMS Beagle for his historic voyage.',
  362: 'In 2014, Sony Pictures was hacked, leaking thousands of confidential documents.',
  363: 'In 2006, Time magazine named "You" as Person of the Year, celebrating user-generated content.',
  364: 'In 2004, the Indian Ocean tsunami triggered one of the largest humanitarian relief efforts in history.',
  365: 'In 1995, JavaScript was created in 10 days by Brendan Eich at Netscape.',
  366: 'In 2016, Vine shut down after Twitter discontinued the short-form video app.',
};

const fallbackFacts = [
  'The first computer bug was an actual moth found in a Harvard Mark II computer in 1947.',
  'The QWERTY keyboard was designed in 1873 to prevent typewriter keys from jamming.',
  'The first 1 GB hard drive, introduced by IBM in 1980, weighed 550 pounds.',
  'More than 500 hours of video are uploaded to YouTube every minute.',
  'The Apollo 11 guidance computer had less processing power than a modern calculator.',
];

function getDayOfYear(date: Date): number {
  const start = new Date(date.getFullYear(), 0, 0);
  const diff = date.getTime() - start.getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

export function getTodayFact(): { fact: string; date: string } {
  const now = new Date();
  const day = getDayOfYear(now);

  const fact =
    facts[day] ?? fallbackFacts[day % fallbackFacts.length];

  const date = now.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return { fact, date };
}
